import React, { Component } from "react";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Swal from "sweetalert2";

//Miscellaneous
import Slider from "react-slick";
import { getUserData } from "../../store/ducks/currentUser/actions";
import { getPromotionBanners } from "../../store/ducks/promos/actions";
import Skeleton from "react-loading-skeleton";
import { isDesktop } from "react-device-detect";

//Components
import PrizesPool from "../../components/Banner/PrizesPool";
import Announcement from "../../components/Announcement/Announcement";
import { withNamespaces } from "react-i18next";

//Icons
import { Icon } from "@iconify/react";

class Banner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      desktop_image_preview: [],
      desktop_image_name: [],
      desktop_image_link: [],
      category: "",
      lang_id: "",
      data: [],
      openModal: false,
      openDropDown: false,
      loading: true,
      currentEvent: "",
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.promotion_banners_data !== this.props.promotion_banners_data) {
      if (nextProps.promotion_banners_data.responseCode === 200) {
        this.setState({ loading: false });
      } else {
        return false;
      }
    }
    return true;
    // if (nextProps.promos_data !== this.props.promos_data) {
    //   if (nextProps.promos_data.responseCode === 200) {
    //     const {
    //       desktop_image_preview,
    //       desktop_image_name,
    //       desktop_image_link,
    //       category,
    //     } = this.state;

    //     nextProps.promos_data.data.promotion.map((item) => {
    //       desktop_image_preview[item] = item.promo_banner_image;
    //       desktop_image_name[item] = "";
    //       desktop_image_link[item] = 'promos/' + item.promotionId;
    //       return item;
    //     });

    //     this.setState({
    //       loading: false,
    //       // desktop_image_preview,
    //       // desktop_image_name,
    //       // desktop_image_link,
    //       // category,
    //     });
    //   } else {
    //     return false;
    //   }
    // }
    // return true;
    // if (nextProps.show_banner_data !== this.props.show_banner_data) {
    //   if (nextProps.show_banner_data.data.responseCode === 200) {
    //     const {
    //       desktop_image_preview,
    //       desktop_image_name,
    //       desktop_image_link,
    //       category,
    //     } = this.state;

    //     nextProps.show_banner_data.data.data.map((item) => {
    //       desktop_image_preview[item] = item.desktop_image;
    //       desktop_image_name[item] = item.desktop_image_name;
    //       desktop_image_link[item] = item.desktop_image_link;
    //       return item;
    //     });

    //     this.setState({
    //       loading: false,
    //       desktop_image_preview,
    //       desktop_image_name,
    //       desktop_image_link,
    //       category,
    //     });
    //   } else {
    //     return false;
    //   }
    // }
    // return true;
  }

  fetchData() {
    // const showBannerData = {};
    // showBannerData.category = this.props.category;
    // this.props.showBanner(showBannerData);

    // const showPromosData = { category_id: "" };
    // this.props.getPromos(showPromosData);

    const getPromotionBannersData = { category_id: "" };
    this.props.getPromotionBanners(getPromotionBannersData);
  }

  imageImport = (r) => {
    let images = {};
    r.keys().map((item) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  redirectUrlHandler = (_, url) => {
    // window.location.replace(url);

    // if not authenticated
    if (!localStorage.getItem("accessToken")) {
      const { t } = this.props;
      Swal.fire({
        iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">' : '',
        icon: "info",
        title: t("global.sorry"),
        text: t("global.login-proceed"),
        confirmButtonText: t("global.ok"),
        showCancelButton: (!isDesktop) ? false : '',
        customClass: (!isDesktop) ? {
          container: "swal-mobile-container sorry",
          icon: "swal-sorry-icon",
        } : []
      }).then((result) => {
        // user click ok button will redirect them to login
        if(result.isConfirmed){
          // store redirect url
          localStorage.setItem("redirectAfterLogin", url);
          // navigate user to login
          window.location.replace("/login")
        }
      });
    } else {
        window.location.replace(url);
    }
  };

  render() {
    const settings = {
      arrows: false,
      dots: true,
      infinite: true,
      fade: true,
      speed: 700,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      adaptiveHeight: false,
      cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
      responsive: [
        {
          breakpoint: 992,
          settings: {
            dots: false,
          },
        },
      ],
    };
    let defaultBanner;
    let bannerCount = 0;
    if (!this.state.loading) {
      let promotion_banners_data = this.props.promotion_banners_data.data.promotion_banners;
      defaultBanner = promotion_banners_data.map((banner, idx) => {
        const bannerAlt = banner.desktop_image_name
          || banner.mobile_image_name
          || banner.title
          || banner.promotion_name
          || `X33 promotion banner ${idx + 1}`;

        bannerCount = bannerCount + 1;

        if (banner.redirect_url) {
          return (
            <Link
              to={{ pathname: banner.redirect_url }}
              key={idx}
              onClick={(event) =>
                this.redirectUrlHandler(event, banner.redirect_url)
              }
            >
              {isDesktop ? (
                <img
                  src={banner.desktop_image}
                  alt={bannerAlt}
                  effect="blur"
                />
              ) : (
                <img
                  src={banner.mobile_image}
                  alt={bannerAlt}
                  effect="blur"
                />
              )}
            </Link>
          );
        }
        else if (banner.id) {
          return (
            <Link
              to={{
                pathname: "/promos-detail/" + banner.id,
                params: { promo_id: banner.id },
              }}
              key={idx}
            >
              {isDesktop ? (
                <img
                  src={banner.desktop_image}
                  alt={bannerAlt}
                  effect="blur"
                />
              ) : (
                <img
                  src={banner.mobile_image}
                  alt={bannerAlt}
                  effect="blur"
                />
              )}
            </Link>
          );
        } else {
          // display plain banner image without the possibility to redirect elsewhere
          return (
            <div>
              <img
              src={isDesktop ? banner.desktop_image : banner.mobile_image}
              alt={bannerAlt}
              key={idx}
              effect="blur"
            />
            </div>
          );
        }
      });
    }

    return (
      <Auxiliary>
        <div className="banner-slick">
          <div className="slick-container">
            {this.state.loading ? (
              <Skeleton
                count={1}
                height="100%"
                style={{ lineHeight: "unset" }}
              />
            ) : (
              <>
                <Slider ref={(c) => (this.slider = c)} {...settings}>
                  {defaultBanner}
                </Slider>
                {/* { window.location.pathname === "/slot" ||
                window.location.pathname.includes("/slot") && isDesktop && 
                  <PrizesPool />
               } */}
                {bannerCount > 1 && isDesktop && (
                  <div className="slick-arrow">
                    <div
                      className="slick-arrow-btn prev"
                      onClick={() => this.slider.slickPrev()}
                    >
                      <Icon icon="uil:angle-left-b" />
                    </div>
                    <div
                      className="slick-arrow-btn next"
                      onClick={() => this.slider.slickNext()}
                    >
                      <Icon icon="uil:angle-right-b" />
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
        <Announcement />
      </Auxiliary>
    );
  }
}

const mapStateToProps = (state) => {
  const { promos } = state;

  return {
    // promos_data: promos.promos_data,
    promotion_banners_data: promos.promotion_banners_data,
    // show_banner_data: banner.show_banner_data,
    currentUser: state.currentUser.data,
  };
};

const mapDispatchToProps = {
  // showBanner,
  getUserData,
  // getPromos,
  // showPromos,
  getPromotionBanners
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(Banner));
